import React, {Component} from 'react'
import {Button, Modal, ModalBody, ModalHeader, FormGroup, FormFeedback, Input, Form, Label} from 'reactstrap'
import PropTypes from 'prop-types'
import {createGasTypeMutation} from './mutations'
import {graphql} from 'react-apollo'
import {WpsStandardizationsAndMaterialsFetch} from '../Wps/mutations'

class GasTypeModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      validation_errors: {},
    }

    this.handleSubmit = this.handleSubmit.bind(this)
  }

  static propTypes = {
    createGasTypeMutation: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    afterSubmit: PropTypes.func.isRequired
  }

  handleSubmit(event) {
    event.preventDefault()

    const form_elements = event.target.elements
    this.props.createGasTypeMutation({
      variables: {
        name: form_elements.name.value,
        description: form_elements.description.value,
      },
      update: (store, {data: {createGasType}}) => {
        if (!createGasType.errors) {
          const data = store.readQuery({query: WpsStandardizationsAndMaterialsFetch})
          data.gas_types.splice(0, 0, createGasType.gas_type)
          store.writeQuery({
            query: WpsStandardizationsAndMaterialsFetch,
            data,
          })
        }
      },
    }).then(({data: {createGasType}}) => {
      if (createGasType.errors) {
        this.setState({validation_errors: JSON.parse(createGasType.errors)})
      } else {
        this.props.afterSubmit(createGasType.gas_type)
      }
    })
  }

  render() {
    return (
      <Modal isOpen={true}>
        <ModalHeader>Add new Gas type</ModalHeader>
        <ModalBody>
          <Form id="gas-type-form" className="FormClassLabel" onSubmit={this.handleSubmit}>
            <FormGroup>
              <Label for="name-gas-type-form">Trade name</Label>
              <Input type="text" name="name" id="name-gas-type-form" required/>
              <FormFeedback>{this.state.validation_errors.name}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="description-gas-type-form">Standard</Label>
              <Input type="text" name="description" id="description-gas-type-form"/>
              <FormFeedback>{this.state.validation_errors.description}</FormFeedback>
            </FormGroup>

            <hr/>
            <Button id="cancel-gas-type-form-btn" className="float-right" color="danger"
              onClick={this.props.onCancel}>Cancel</Button>
            <Button id="save-gas-type-form-btn" className="float-right" color="primary" type="submit">Save</Button>
          </Form>
        </ModalBody>
      </Modal>
    )
  }
}

const GasTypeModalWithMutations = graphql(createGasTypeMutation, {name: 'createGasTypeMutation'})(GasTypeModal)

export default GasTypeModalWithMutations



// WEBPACK FOOTER //
// ./src/components/Dictionary/GasTypeModal.js